// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__1YNcr"};